import "../styles/style.css";
import sslImage from "../assests/sslCertificate.png";
import Header from "./Header";
import Loader from "./Loader";
import { useState, useEffect } from "react";
import mixpanel from "mixpanel-browser";
import OtpInput from 'react-otp-input';
import otp_img from "../assests/otp-copy.png"
import { otpVerify, resendOtp } from "../redux/actions/document";
import { toast,ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
mixpanel.init(process.env.REACT_APP_MIX_PANEL_TOKEN, { debug: true, api_host: process.env.REACT_APP_MIXPANEL_API_HOST });

const options = {
    position: "top-center",
    autoClose: 2500,
    closeButton: false,
    limit: 1,
    type: "success",
    theme: "colored",
};
const OtpVerify = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setLoading] = useState(false);
    const [otp, setOtp] = useState("");
    const [counter, setCounter] = useState(90);

    // console.log("propspropsprops",props.location.state.message);
    useEffect(() => {
        mixpanel.track("Viewed_Enter_OTP", { status: true })
    }, []);
    useEffect(()=>{
        toast.success(location?.state?.message, options);

    },[])
    useEffect(() => {
       
        const timer =
            counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
        return () => clearInterval(timer);
    }, [counter]);
    let data = JSON.parse(localStorage.getItem("state"))

    const handleVerifyOtp = (e) => {
        e.preventDefault();
        mixpanel.track("Interacted_Enter_OTP", { status: true })
        let reqBody = {
            otp: otp,
            token: data?.ekyc?.token
        };
        setLoading(true);
        otpVerify(reqBody)
            .then((res) => {
                setLoading(false);
                navigate("/address", { state: { statusValue: "ckyc_selfie" } });
            })
            .catch((err) => {
                setLoading(false);
                if (err.response.status == 412) {

                    confirmAlert({
                        customUI: ({ onClose }) => {
                            return (
                                <div className="custom-ui">
                                    <h1>Error</h1>
                                    <div style={{ color: "#152745" }} className="errMessage">
                                        {err?.response?.data?.error}
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignContent: "center",
                                        }}
                                    >
                                        <button
                                            style={{
                                                backgroundColor: "#FC6603",
                                                color: "#FFFFFF",
                                                border: "none",
                                                outline: "none",
                                                borderRadius: 5,
                                                padding: "2px 20px 2px 16px"
                                            }}
                                            onClick={onClose}
                                        >
                                            OK
                                        </button>
                                    </div>
                                </div>
                            );
                        },
                    });
                } else {
                    navigate("/adharnumber");
                }
            });
    };
    const handleResendOtp = (e) => {
        setOtp("");
        setCounter(90);
        e.preventDefault();
        setLoading(true);
        let token = data?.ekyc?.token
        resendOtp(token)
            .then((res) => {
                setLoading(false);
                toast.success(res?.data?.message, options);

            })
            .catch((err) => {
                setLoading(false);
                if (err.response.status == 412) {

                    confirmAlert({
                        customUI: ({ onClose }) => {
                            return (
                                <div className="custom-ui">
                                    <h1>Error</h1>
                                    <div style={{ color: "#152745" }} className="errMessage">
                                        {err?.response?.data?.error}
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignContent: "center",
                                        }}
                                    >
                                        <button
                                            style={{
                                                backgroundColor: "#FC6603",
                                                color: "#FFFFFF",
                                                border: "none",
                                                outline: "none",
                                                borderRadius: 5,
                                                padding: "2px 20px 2px 16px"
                                            }}
                                            onClick={onClose}
                                        >
                                            OK
                                        </button>
                                    </div>
                                </div>
                            );
                        },
                    });
                }
            });
    };
    return (
        <>
            {isLoading ? (
                <div className="react_loading">
                    <Loader />
                </div>
            ) : null}
            <div className="otp-wrapper">
                <Header heading="OTP Verification" />
            <div className="container">
                {/* <p className="text-left"><b>Enter the OTP you received to XXXXXX${phone_number?.slice(6, 10)}</b></p> */}
                <p className="text-left mt-20"><b>{location?.state?.message}</b></p>
                <div className="otp-wrapper text-center">
                    <img src={otp_img} alt="otp" width={130} height={160} className="mb-30 mt-20" />
                </div>
                <OtpInput
                    value={otp}
                    onChange={(value) => {
                        if (value === "" || /^[0-9\b]+$/.test(value)) {
                        setOtp(value);
                        }
                    }}
                    inputType="tel"
                    isInputNum={true}
                    numInputs={6}
                    renderSeparator={""}
                    renderInput={(props) => <input {...props} />}
                    containerStyle="otp-input mb-20"
                />
                <div className="timer">
                    <p>
                        <strong>Didn&apos;t receive OTP?</strong>
                    </p>
                    <p
                        onClick={
                            counter === 0
                                ? (e) => {
                                    handleResendOtp(e);
                                }
                                : null
                        }
                        className={counter === 0 ? "text_click" : "disabled"}
                        disabled={!(counter === 0)}
                    >
                        Resend {counter > 0 ? `in ${counter}s` : ``}
                    </p>
                </div>
                <div className="button-wrapper text-center mt-30">
                    <button
                        className="btn bg-orange btnContinue text-white rounded-lg px-5"
                        onClick={handleVerifyOtp}
                        disabled={!(otp.length === 6)}
                        data-testid="btn"
                    >
                        Continue
                    </button>
                    <div className="imgDiv">
                        <img src={sslImage} className="sslImage" />
                    </div>
                </div>
            </div>
            </div>
        </>
    );
};
export default (OtpVerify);